let Utils = {
  isDefined(val) {
    return (typeof val !== 'undefined' && val !== null)
  },
  
  getParameterByName(name, url = window.location.href) {
    name = name.replace(/[\[\]]/g, '\\$&');
    let regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'), results = regex.exec(url);
    if (!results) {
      return null;
    }
    if (!results[2]) {
      return '';
    }
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  },
  
  isValidEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  },
  
  getWorkspaceId() {
    let scripts = document.getElementsByTagName('script');
    let workspace_id = "";

    for (let i = 0; i < scripts.length; i++) {
      let src = scripts[i].getAttribute('src');
      if (src && (src.includes('livechat') || src.includes('dist/livechat.iife.js'))) {
        workspace_id = scripts[i].getAttribute('data-superagi-workspace');
        if (workspace_id) {
          break;
        }
        let match = src.match(/workspace_id=([^&]*)/);
        if (match) {
          workspace_id = match[1];
          break;
        }
      }
    }

    if (!workspace_id) {
      workspace_id = Utils.getParameterByName('workspace_id');
    }

    return workspace_id;
  },

  getUserId() {
    let scripts = document.getElementsByTagName('script');
    let user_id = "";

    for (let i = 0; i < scripts.length; i++) {
      let src = scripts[i].getAttribute('src');
      if (src && (src.includes('livechat') || src.includes('dist/livechat.iife.js'))) {
        user_id = scripts[i].getAttribute('data-superagi-user-id');
        if (user_id) {
          break;
        }
      }
    }

    if (!user_id) {
      user_id = Utils.getParameterByName('user_id');
    }

    return user_id;
  },
  
  generateUniqueId() {
    return Date.now().toString(36) + Math.random().toString(36).substr(2);
  }
}

export default Utils;
